var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpa = function SvgSpa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.725 5a2 2 0 100-4 2 2 0 000 4zM8.058 5.11a2 2 0 011.401 1.823l2.216 2.492 4.316 1.812a1 1 0 01-.774 1.844l-4.526-1.9a1 1 0 01-.36-.257L8.854 9.262 7.49 13.617a2 2 0 01-3.817-1.195l1.879-6A2 2 0 018.058 5.11zM21.085 17.57a2 2 0 11-4 0 2 2 0 014 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.18 19.024a2 2 0 00-1.73-3.005H3a2 2 0 100 4h11.268l2.903 2.49a1 1 0 00.65.241H22a1 1 0 100-2h-3.808l-2.013-1.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 22.02a1 1 0 011-1h11.45a1 1 0 110 2H2a1 1 0 01-1-1z"
  }))));
};
export default SvgSpa;